import { render, staticRenderFns } from "./source_material_item.vue?vue&type=template&id=42c88e54&scoped=true&"
import script from "./source_material_item.vue?vue&type=script&lang=js&"
export * from "./source_material_item.vue?vue&type=script&lang=js&"
import style0 from "./source_material_item.vue?vue&type=style&index=0&id=42c88e54&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c88e54",
  null
  
)

export default component.exports